<div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
    <h4 class="matDialogTitle" mat-dialog-title [textContent]="data.title"></h4>
    <span class="material-icons mb-1" mat-dialog-close>close</span>
</div>
<hr id="hrLine" />
<mat-form-field appearance="outline" *transloco="let translate">
    <mat-label [textContent]="translate('Enter template name to save')"></mat-label>
    <input required matInput placeholder="placeholder" [(ngModel)]="templateName" />
</mat-form-field>
<span class="errorMsg" [textContent]="nameError"></span>

<mat-dialog-actions align="center" *transloco="let translate">
    <material-button mat-dialog-close [color]="'default'" [text]="translate('Cancel')"></material-button>
    <material-button [color]="'primary'" [text]="translate('Save Template')" (buttonClicked)="saveTemplate()"></material-button>
</mat-dialog-actions>
